module.exports = __webpack_public_path__ + "static/Gameplay_GingerBrave-e9c2bc55051ea4b4cce9545241f4f965.png";